
/**
 * Collection of functions to calculate project informations
 */

import { defaultsDeep } from "lodash";
import moment from "moment/moment";


function calculateProjectInfo(project) {
    let projectInfo = {
        taskNumber: project?.tasks?.length,
        subTaskNumber: 0,
        resourceNumber: 0,
        hours: 0,
        hours_real: 0,
        resourcePrice: null,
        price: 0,
        realPrice: 0,
        progress: 0,
        hoursLeft: 0,
        priceDiff: 0,
        addictionalCosts: 0
    };

    let resourceCostCount = 0;
    let progress = 0;
    if (project?.tasks) {
        for (let task of project.tasks) {
            const e = calculateTaskInfo(task);
            if (e.resourcePrice) {
                if (!projectInfo.resourcePrice)
                    projectInfo.resourcePrice = 0;
                projectInfo.resourcePrice += e.resourcePrice;
                resourceCostCount++;
            }

            progress += e.progress * (e.hours || 0);
            if (e.hours)
                projectInfo.hours += e.hours;
            if (e.hours_real)
                projectInfo.hours_real += e.hours_real;
            if (e.price)
                projectInfo.price += e.price;
            if (e.realPrice)
                projectInfo.realPrice += e.realPrice;
            projectInfo.subTaskNumber += e.subTaskNumber;
            projectInfo.resourceNumber += e.resourceNumber;
        }
    }
    projectInfo.progress = progress / projectInfo.hours;

    if (resourceCostCount > 0) {
        projectInfo.resourcePrice = projectInfo.resourcePrice / resourceCostCount;
    }

    projectInfo.addictionalCosts = project.addictional_costs.reduce((total, item) => {
        return total + (parseFloat(item.cost) || 0);
      }, 0);

    projectInfo.realPrice += projectInfo.addictionalCosts;

    projectInfo.priceDiff = projectInfo.realPrice - projectInfo.price;
    projectInfo.hoursLeft = Math.round((1 - projectInfo.progress / 100) * projectInfo.hours);

    projectInfo.revenue = project.client_price - projectInfo.realPrice;
    projectInfo.client_price = project.client_price;
    
    

    return projectInfo;
}
/**
 * 
 * @param {object} task 
 * @returns {object}
 */
function calculateTaskInfo(task) {
    let taskInfo = {
        subTaskNumber: task.sub_tasks.length,
        resourceNumber: 0,
        hours: 0,
        hours_real: 0,
        resourcePrice: null,
        price: 0,
        realPrice: 0,
        priceDiff: 0,

        progress: 0,
    };

    let resourceCostCount = 0;

    const subtaskInfos = task.sub_tasks.map((e) => calculateSubTaskInfo(e));

    let useWeightedProgress = true;
    for (let e of subtaskInfos) {
        //const e = calculateSubTaskInfo(subTask);
        if (e.resourcePrice) {
            if (!taskInfo.resourcePrice)
                taskInfo.resourcePrice = 0;
            taskInfo.resourcePrice += e.resourcePrice;
            resourceCostCount++;
        }

        //progress += e.progress * (e.hours || 0);


        if (e.hours)
            taskInfo.hours += e.hours;
        else
            useWeightedProgress = false;
        if (e.hours_real)
            taskInfo.hours_real += e.hours_real;
        if (e.price)
            taskInfo.price += e.price;
        if (e.realPrice)
            taskInfo.realPrice += e.realPrice;

        taskInfo.resourceNumber += e.resourceNumber;


    }

    let progress = 0;
    if (useWeightedProgress && taskInfo.hours > 0) {
        //taskInfo.progress = progress / taskInfo.hours;

        ///Has hours, avg with weights

        //console.warn({ taskInfo })


        for (let e of subtaskInfos) {
            if (e.hours) {
                progress += e.progress * (e.hours / taskInfo.hours);
            }
        }
        progress = Math.floor(progress);
    } else {
        ///no hours specified, avg without weights

        for (let e of subtaskInfos) {
            progress += e.progress;
        }
        progress = progress / subtaskInfos.length;

    }
    //console.log("taskinfo", task.name, taskInfo.progress, progress)
    taskInfo.progress = progress;


    console.warn('task taskInfo.progress:', taskInfo.progress);
    if (resourceCostCount > 0) {
        taskInfo.resourcePrice = taskInfo.resourcePrice / resourceCostCount;
    }

    taskInfo.priceDiff = taskInfo.realPrice - taskInfo.price;
    return taskInfo;
}

function calculateSubTaskInfo(subTask) {

    let info = {
        hours: 0,
        hours_real: 0,
        resourcePrice: null,
        price: 0,
        realPrice: 0,
        priceDiff: 0,
        resourceNumber: subTask.resources.length,
        progress: subTask.progress,
    };

    let resourceCostCount = 0;
    for (let resource of subTask.resources) {
        const e = calculateSubtaskResourceInfo(resource);
        if (e.resourcePrice) {
            if (!info.resourcePrice)
                info.resourcePrice = 0;
            info.resourcePrice += e.resourcePrice;
            resourceCostCount++;
        }

        if (e.hours)
            info.hours += e.hours;
        if (e.hours_real)
            info.hours_real += e.hours_real;
        if (e.price)
            info.price += e.price;
        if (e.realPrice)
            info.realPrice += e.realPrice;

        info.priceDiff += e.priceDiff;
    }
    /// medium price
    if (resourceCostCount > 0) {
        info.resourcePrice = info.resourcePrice / resourceCostCount;
    }

    return info;
}

function calculateSubtaskResourceInfo(taskRes) {
    /**
     * 
        'sub_task_id',
        'resource_id',
        'date_start',
        'date_end',
        'hours',
        'hours_real',
        'price',
        'active'
     */
    if (!taskRes.resource) {
        return {
            hours: taskRes.hours,
            hours_real: taskRes.hours_real,
            resourcePrice: null,
            price: null,
            realPrice: null,
            priceDiff: 0,
        };
    }
    const hours = taskRes.hours;
    const hours_real = taskRes.hours_real;
    const resourcePrice = taskRes.resource.price;
    const isSupplier = taskRes.resource.type === 'supplier';

    /// fornitore esterno, prezzo in taskRes.price
    if (isSupplier) {
        const price = taskRes.price || 0;
        return {
            hours: taskRes.hours,
            hours_real: taskRes.hours_real,
            resourcePrice,
            price,
            realPrice: price,
            priceDiff: 0,
        };
    }

    const realPrice = (resourcePrice && hours_real > 0) ? resourcePrice * hours_real : null;
    const price = (resourcePrice && hours > 0) ? resourcePrice * hours : null;

    const priceDiff = realPrice && price ? realPrice - price : 0;

    return {
        hours,
        hours_real,
        resourcePrice,
        price,
        realPrice,
        priceDiff,
    };
}


function calculateTaskPrice(task) {
    return calculateTaskInfo(task).price;
}

function calculateTaskRealPrice(task) {
    return calculateTaskInfo(task).realPrice;
}

function calculateSubTaskPrice(subTask) {
    return calculateSubTaskInfo(subTask).price;
}
function calculateSubTaskRealPrice(subTask) {
    return calculateSubTaskInfo(subTask).realPrice;
}


function NormalizeProject(project) {
    const data = Object.assign({
        id: null,
        customer_id: null,
        customer: null,
        project_manager_id: null,
        project_manager: null,
        name: '',
        description: '',
        date_start: null,
        date_end: null,
        active: true,
        completed: false,
        tasks: [],
        document_lists: [],
        addictional_costs: [],
    }, project || {});//todo

    data.tasks = data.tasks.map(task => NormalizeTask(task));
    data.document_lists = data.document_lists.map(task => NormalizeDocumentList(task));
    return data;
}

function NormalizeTask(task) {

    const data = Object.assign({
        id: null,
        customer_id: null,
        customer: null,
        name: '',
        description: '',
        date_start: null,
        date_end: null,
        active: true,
        tasks: [],
    }, task || {});//todo

    data.tasks = data.tasks.map(task => NormalizeTask(task));
    return data;
}

function NormalizeSubTask(subtask) {
    const data = Object.assign({
        id: null,

        task: null,///required!
        task_id: null,


        name: '',
        description: '',
        date_start: null,
        date_end: null,
        active: true,
        progress: 0,
        ///
        resources: [],
        sals: [],

    }, subtask || {});
    data.resources = data.resources.map(resource => NormalizeSubTaskResource(resource));
    data.sals = data.sals.map(sals => NormalizeSal(sals));
    return data;
}

function NormalizeDocumentList(item) {
    const data = Object.assign({
        id: null,
        project_id: null,
        project: null,
        title: null,
        description: null,
        category: null,

        is_private: false,
        //file:null,
        url: null,
        done: false,

        uploaded_at: null,

        user_id: null,
        user: null,

    }, item || {});

    return data;
}

function NormalizeSubTaskResource(resource) {
    const data = Object.assign({
        id: Symbol(),
        sub_task_id: null,
        sub_task: null,

        resource: null,///required!
        resource_id: null,
        ///
        hours: 0,
        hours_real: 0,

        price: 0,
        active: true,


        date_start: null,
        date_end: null,



    }, resource || {});


    return data;
}
function NormalizeSal(v) {
    const data = Object.assign({
        id: Symbol(),
        date: '',
        percent: 0,
        description: '',
    }, v || {});
    return data;
}

function getUUID(prefix) {
    return (prefix || '') + (Math.floor(Date.now() + Math.random() * 1000000)).toString(36);
}

export {
    getUUID,
    calculateProjectInfo,
    calculateTaskInfo,
    calculateSubTaskInfo,
    calculateSubtaskResourceInfo,
    calculateSubTaskPrice,
    calculateTaskPrice,
    calculateTaskRealPrice,

    NormalizeProject,
    NormalizeTask,
    NormalizeSubTask,
    NormalizeSubTaskResource,
    NormalizeSal,
    NormalizeDocumentList,
};